import React from "react";
import s from "../mobile.module.css";
import { Button, TimePicker, message } from "antd";
import moment from "moment";
import 'moment/locale/ru';

// Устанавливаем русскую локаль
moment.locale('ru');

const Time = (props) => {
    const setTimeStart = (time) => {
        if (time) {
            // Проверка: время начала не может быть в будущем
            if (time.isAfter(moment())) {
                message.warning('Время начала не может быть в будущем');
                return;
            }

            // Проверка: если время окончания уже установлено, оно должно быть после времени начала
            if (props.timeEnd.time && time.isAfter(props.timeEnd.time)) {
                message.warning('Время начала не может быть позже времени окончания');
                return;
            }

            props.setTimeStart({ status: true, time });
        }
    }

    const setTimeEnd = (time) => {
        if (time) {
            // Проверка: время окончания не может быть раньше времени начала
            if (props.timeStart.time && time.isBefore(props.timeStart.time)) {
                message.warning('Время окончания не может быть раньше времени начала');
                return;
            }

            // Проверка: время окончания не может быть в будущем
            if (time.isAfter(moment())) {
                message.warning('Время окончания не может быть в будущем');
                return;
            }

            props.setTimeEnd({ status: true, time });
        }
    }

    // Функция для отключения времени в будущем
    const disabledFutureTime = (current) => {
        return current && current > moment().endOf('day');
    }

    // Функция для отключения времени до времени начала
    const disabledTimeBeforeStart = (current) => {
        if (!props.timeStart.time) return false;
        return current && current < props.timeStart.time;
    }

    return (
        <div className={s.time_cont}>
            <div className={s.reportTitle}>Время начала работ на объекте</div>
            <div className={s.time}>
                <TimePicker
                    placeholder={'Укажите время'}
                    defaultValue={props.timeStart.time}
                    value={props.timeStart.time}
                    size={'large'}
                    className={s.timePicker}
                    format={'HH:mm'}
                    onChange={setTimeStart}
                    disabledTime={disabledFutureTime}
                    showNow={false}
                />
            </div>

            <div className={s.reportTitle}>Время окончания работ на объекте</div>
            <div className={s.time}>
                <TimePicker
                    placeholder={'Укажите время'}
                    defaultValue={props.timeEnd.time}
                    value={props.timeEnd.time}
                    size={'large'}
                    className={s.timePicker}
                    format={'HH:mm'}
                    onChange={setTimeEnd}
                    disabledTime={(current) =>
                        disabledFutureTime(current) || disabledTimeBeforeStart(current)
                    }
                    showNow={false}
                    disabled={!props.timeStart.time}
                />
            </div>

            {props.timeStart.time && props.timeEnd.time && (
                <div style={{
                    textAlign: 'center',
                    marginTop: '16px',
                    padding: '8px',
                    backgroundColor: '#f6ffed',
                    border: '1px solid #b7eb8f',
                    borderRadius: '6px'
                }}>
                    <strong>Продолжительность работ:</strong><br />
                    {moment.duration(props.timeEnd.time.diff(props.timeStart.time)).hours()} часов {' '}
                    {moment.duration(props.timeEnd.time.diff(props.timeStart.time)).minutes()} минут
                </div>
            )}
        </div>
    )
}

export default Time;